import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import News from '../components/News';
import About from '../components/About';
import Research from '../components/Research';
import PublicationsReal from '../components/PublicationsReal';
import Funding from '../components/Funding';
import Recruitment from '../components/Recruitment';
import Collaborators from '../components/Collaborators';
import Contact from '../components/Contact';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <News />
        <About />
        <Research />
        <PublicationsReal />
        <Funding />
        <Recruitment />
        <Collaborators />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
